import { createFileRoute } from '@tanstack/react-router'

import { EmailConfigSection } from '@/components/Internal/GlobalConfig/EmailConfigSection'

export const Route = createFileRoute('/internal/system/settings/email')({
  component: EmailConfigSection,
})
